import { isFieldError } from "../helpers";

import Input from "../components/Input";
import RadiosScale from "../components/RadiosScale";

export default function Q5Fields({ handleUpdate, errors }) {
	return (
		<>
			<h4 style={{ fontSize: "1.15rem" }}>
				5. Communication Throughout the Event Planning Process
			</h4>

			<div
				className="form-group radios"
				style={{ marginTop: "15px", marginBottom: "0" }}
			>
				<RadiosScale
					label="5.1 How effective was the overall communication you received related to the Event?"
					reqd={true}
					data={[
						{
							name: "q5_1",
							val: "1",
							label: "1 - Poor",
						},
						{
							name: "q5_1",
							val: "2",
							label: "2 - Fair",
						},
						{
							name: "q5_1",
							val: "3",
							label: "3 - Good",
						},
						{
							name: "q5_1",
							val: "4",
							label: "4 - Very Good",
						},
						{
							name: "q5_1",
							val: "5",
							label: "5 - Excellent",
						},
					]}
					value={""}
					click={handleUpdate}
					error={isFieldError(errors, "q5_1") ? true : false}
				/>
			</div>

			<div
				className="form-group radios"
				style={{ marginTop: "15px", marginBottom: "0" }}
			>
				<RadiosScale
					label="5.2 Were you informed of important updates in a timely manner?"
					reqd={true}
					data={[
						{
							name: "q5_2",
							val: "1",
							label: "1 - Poor",
						},
						{
							name: "q5_2",
							val: "2",
							label: "2 - Fair",
						},
						{
							name: "q5_2",
							val: "3",
							label: "3 - Good",
						},
						{
							name: "q5_2",
							val: "4",
							label: "4 - Very Good",
						},
						{
							name: "q5_2",
							val: "5",
							label: "5 - Excellent",
						},
					]}
					value={""}
					click={handleUpdate}
					error={isFieldError(errors, "q5_2") ? true : false}
				/>
			</div>

			<div className="form-group one " style={{ marginTop: "15px" }}>
				<Input
					name="q5_3"
					label="5.3 What communication improvements would help you better support your attendees?"
					reqd={true}
					value={""}
					autocomplete="off"
					update={handleUpdate}
					errors={errors}
				/>
			</div>
		</>
	);
}
